module.exports = __webpack_public_path__ + "static/img/img-tec-03-line.85700e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/img-tec-03-line.png
// module id = oVxq
// module chunks = 1